import { faCircleArrowLeft } from "@fortawesome/free-solid-svg-icons/faCircleArrowLeft";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { classeParaLabelsFormularioComFundoEscuroSimplificada } from "app/estilos/classeParaLabelsFormularioComFundoEscuro";
import { Documento } from "app/types/cliente/RespostaDocumentosAbertos";
import clsx from "clsx";
import React from "react";
import globalMU from "../../../globalMU";
import { DadosDocumentos } from "../documentos-abertos/DocumentosAbertos";

export type DocumentosAbertosInformacoesProps = {
  documentosAbertosInformacoes: Documento;
  cpfcnpj: string;
  nome: string;
};

export const DocumentosAbertosInformacoes = (props: DocumentosAbertosInformacoesProps) => {
  const estilosFormulario = require('../../estilos/formulario.module.scss').default
  
  const dadosDetalhamentoDocAberto = 
      <section id="documentosAbertosCliente_dadosCliente" 
          className={clsx(estilosFormulario.formularioSimplificado, classeParaLabelsFormularioComFundoEscuroSimplificada)}>
          <label>CNPJ</label><span>{props.cpfcnpj}</span>
          <label>Nome</label><span>{props.nome}</span>

          <label>Número</label><span style={{ fontWeight: 700, backgroundColor: "var(--mu-superficie, #FFFFFF)"}}>{props.documentosAbertosInformacoes?.Numero}</span>


          <label>Vencimento</label><span>{props.documentosAbertosInformacoes?.Vencimento}</span>
          <label>Valor</label><span>{globalMU.formatarValorNumerico(props.documentosAbertosInformacoes?.Valor,2)}</span>
          <label>Atraso</label><span>{globalMU.formatarValorNumerico(props.documentosAbertosInformacoes?.Atraso,0)}</span>
          <label>Créditos</label><span>{globalMU.formatarValorNumerico(props.documentosAbertosInformacoes?.Creditos,2)}</span>
          <label>Encargos</label><span>{globalMU.formatarValorNumerico(props.documentosAbertosInformacoes?.Encargos,2)}</span>
          <label>Descontos</label><span>{globalMU.formatarValorNumerico(props.documentosAbertosInformacoes?.Desconto,2)}</span>
          <label>Total</label><span>{globalMU.formatarValorNumerico(props.documentosAbertosInformacoes?.ValorTotal,2)}</span>
          <label>Descrição</label><span>{props.documentosAbertosInformacoes?.Descricao}</span>
          <label>Histórico</label><span>{props.documentosAbertosInformacoes?.Historico}</span>
          <label>Data Emissão</label><span>{props.documentosAbertosInformacoes?.DataEmissao}</span>
          <label>Orçamento</label><span>{props.documentosAbertosInformacoes?.NumeroOrcamento}</span>
          <label>Vendedor</label><span>{props.documentosAbertosInformacoes?.Vendedor}</span>
          <label>Local Portador</label><span>{props.documentosAbertosInformacoes?.LocalPortador}</span>
          <label>Situação Cobrança</label><span>{props.documentosAbertosInformacoes?.SituacaoCobranca}</span>
          <label>Cartório Protesto</label><span>{props.documentosAbertosInformacoes?.CartorioProtesto}</span>
          {<section style={{ marginBottom: "100px" }} />}
      </section>


  return (
     <div>
      {dadosDetalhamentoDocAberto}
    </div>
  );
}; 
